import Header from "../components/common/Header";

function HomeBD() {
  return (
    <>
      <Header sign="not"></Header>
      <div className="background-home">
        <div>
          Trello tập hợp tất cả nhiệm vụ, thành viên nhóm và công cụ của bạn lại
          với nhau
        </div>
        <img
          src="https://images.ctfassets.net/rz1oowkt5gyp/75rDABL8fyMtNLlUAtBxrg/c5e145977a86c41c47e17c69410c64f7/TrelloUICollage_4x.png?w=2280&fm=webp"
          alt=""
        />
      </div>
    </>
  );
}

export default HomeBD;
